import React, { Component } from 'react';
import axios from 'axios';
import '../../assets/css/Register.css';
import { connect } from 'react-redux';
import Button from '../Button';
import {changeCurrentUser} from '../../state/actionCreators/index'
import ForgotPasswordPopup from '../Popups/ForgotPwdPopup';
import PasswordReqPopup from '../Popups/PasswordReqPopup';

class Register extends Component {
    constructor() {
        super();
        this.state = {
            email: '',
            password: '',
            displayName: '',
            isSignUpActive: true,
            error: '',
            popupMsg: 'demo',
            showPopup: false,
            pwdScore: 0,
            forgotPwdPp: React.createRef(),
            pwdReqPp: React.createRef(),
        };
    }

    componentDidMount() {
        if(process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY) {
            if (!document.querySelector(`script[src*="recaptcha"]`)) {
                const script = document.createElement("script");
                script.src = `https://www.google.com/recaptcha/api.js?render=${process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY}&v=3`;
                script.async = true;
                script.defer = true;
            
                script.onload = () => {
                  console.log("reCAPTCHA script loaded successfully.");
                };
            
                document.head.appendChild(script);
            } 
        }
    }
      
    executeRecaptcha = () => {
        return new Promise((resolve, reject) => {
            if (window.grecaptcha && window.grecaptcha.ready) {
                window.grecaptcha.ready(() => {
                    window.grecaptcha
                        .execute(process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY, { action: "submit" })
                        .then((token) => {
                            resolve(token);
                        })
                        .catch((error) => {
                            console.error("reCAPTCHA error:", error);
                            reject(error);
                        });
                });
            } else {
                console.error("reCAPTCHA is not loaded yet.");
                reject("reCAPTCHA not loaded");
            }
        });
    };    

    validatePassword = (password) => {
        const errors = [];

        let score = 0;
        password.length < 8 ? errors.push("Password must be at least 8 characters long.") : score++;
        
        /[A-Z]/.test(password) ? score++ : errors.push("Password must include at least one uppercase letter.");
        
        /[a-z]/.test(password) ? score++ : errors.push("Password must include at least one lowercase letter.");

        /[0-9]/.test(password) ? score++ : errors.push("Password must include at least one number.");

        /[!@#$%^&*(),.?":{}|<>]/.test(password) ? score++ : errors.push("Password must include at least one special character.");

        return {
            isValid: errors.length === 0,
            errors,
            score
        };
    }

    handleSignUp = async (e) => {
        e.preventDefault();

        this.setState((prevState) => {
            return ({
                ...prevState,
                error: ""
            })
        })

        const pwdValidationResult = this.validatePassword(this.state.password);
        if(!pwdValidationResult.isValid) {
            this.setState({error: pwdValidationResult.errors[0]});
            return;
        }

        let token = null;
        if(process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY) {
            token = await this.executeRecaptcha();
        } 

        var request_body = { email: this.state.email, password: this.state.password, displayName: this.state.displayName, recaptcha: token };
        axios.post(process.env.REACT_APP_SERVER_URL + `/user`, request_body)
            .then((response) => {
                localStorage.setItem('token', response.data.user.token);
                localStorage.setItem('userId', response.data.user.id)
                this.props.changeCurrentUser(response.data.user)
                window.location.href = "/home";
            })
            .catch((error) => {
                if (error.response) {
                    if (error.response.status == 400 && error.response.data.fieldErrors) {
                        const fieldErrors = error.response.data.fieldErrors;
                        const firstKey = Object.keys(fieldErrors)[0];
                        const firstError = fieldErrors[firstKey];

                        this.setState((prevState) => ({
                            ...prevState,
                            error: firstError
                        }));
                    }
                    else {
                        this.setState((prevState) => {
                            return ({
                                ...prevState,
                                error: error.response.data
                            })
                        })
                    }
                }
            });
    }

    handleSignIn = async (e) => {
        e.preventDefault();

        this.setState((prevState) => {
            return ({
                ...prevState,
                error: ""
            })
        })

        let token = null;
        if(process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY) {
            token = await this.executeRecaptcha();
        } 

        var request_body = { email: this.state.email, password: this.state.password, recaptcha: token };

        axios.post(process.env.REACT_APP_SERVER_URL + `/user/login`, request_body)
            .then((response) => {
                localStorage.setItem('token', response.data.user.token);
                localStorage.setItem('userId', response.data.user.id);
                this.props.changeCurrentUser(response.data.user)
                window.location.href = "/home";
            })
            .catch((error) => {
                console.log(error)
                if (error.response) {
                    if (error.response.status == 400 && error.response.data.fieldErrors) {

                        const fieldErrors = error.response.data.fieldErrors;
                        const firstKey = Object.keys(fieldErrors)[0];
                        const firstError = fieldErrors[firstKey];

                        this.setState((prevState) => ({
                            ...prevState,
                            error: firstError
                        }));
                    }
                    else {

                        this.setState((prevState) => {
                            return ({
                                ...prevState,
                                error: error.response.data
                            })
                        })
                    }
                } else {
                    this.setState((prevState) => {
                        return ({
                            ...prevState,
                            error: error
                        })
                    })
                }
            });
    }

    handleForgetPass = (e) => {
        this.state.forgotPwdPp.current.openPopup()
    }

    handleClosePopup = () => {
        this.setState({ showPopup: false });
    };

    // Handle form input change
    handleInputChange = (e) => {
        let name = e.target.name;
        let value = e.target.value;
        this.setState((prevState) => {
            return ({
                ...prevState,
                [name]: value
            })
        })

        if(name === 'password') {
            let pwdValidation = this.validatePassword(value);
            this.setState({pwdScore: pwdValidation.score})
        }
    }

    togglePanel = () => {
        this.setState((prevState) => {
            return ({
                ...prevState,
                isSignUpActive: !prevState.isSignUpActive,
                error: '',
            })
        })
    }

    render() {
        let { displayName, email, password, isSignUpActive, error, pwdScore } = this.state;

        let pwdScoreClass = '';
        let pwdScoreText = '';
        switch (pwdScore) {
            case 0:
            case 1:
                pwdScoreClass = 'mjwi-pwd-level-1';
                pwdScoreText = 'Poor';
                break;
            case 2:
                pwdScoreClass = 'mjwi-pwd-level-2';
                pwdScoreText = 'Weak';
                break;
            case 3:
                pwdScoreClass = 'mjwi-pwd-level-3';
                pwdScoreText = 'Fair';
                break;
            case 4:
                pwdScoreClass = 'mjwi-pwd-level-4';
                pwdScoreText = 'Good';
                break;
            case 5:
                pwdScoreClass = 'mjwi-pwd-level-5';
                pwdScoreText = 'Strong';
                break;
        }

        return (
            <div className="mjwi-register-wrapper">
                <div className={`mjwi-rg-container ${isSignUpActive ? "right-panel-active" : ""}`} id="mjwi-rg-container">
                    <div className={`mjwi-rg-form-container ${isSignUpActive ? "mjwi-rg-sign-up-container" : "mjwi-rg-sign-in-container"}`}>
                        <form action="#">
                            <h1>{isSignUpActive ? "Create Account" : "Sign In"}</h1>

                            {isSignUpActive && (
                                <div className='mjwi-register-usrname'><i className="fa-solid fa-user"></i><input
                                    type="text"
                                    placeholder="Your Name"
                                    name="displayName"
                                    value={displayName}
                                    onChange={this.handleInputChange}
                                /></div>
                            )}

                            <div className='mjwi-register-emailadrs'><i className="fa-solid fa-envelope"></i><input
                                type="email"
                                placeholder="Email Address"
                                name="email"
                                value={email}
                                onChange={this.handleInputChange}
                            /></div>

                            <div className='mjwi-register-passwrd'><i className="fa-solid fa-lock"></i><input
                                type="password"
                                placeholder="Password"
                                name="password"
                                value={password}
                                onChange={this.handleInputChange}
                            />{isSignUpActive && <i class="fa-solid fa-circle-info" onClick={() => this.state.pwdReqPp.current.openPopup()}></i>}</div>
                            {isSignUpActive && password.length > 0 &&
                            <div className='mjwi-strength-container'>
                                <div id="mjwi-strength-bar">
                                    <div id='mjwi-strength' className={pwdScoreClass}></div>
                                </div>
                                <span id="mjwi-strength-text">{pwdScoreText}</span>
                            </div>}

                            {isSignUpActive ? (
                                <button
                                    onClick={this.handleSignUp}
                                    disabled={!displayName || !email || !password}
                                >
                                    Sign Up
                                </button>
                            ) : (
                                <button
                                    onClick={this.handleSignIn}
                                    disabled={!email || !password}
                                >
                                    Sign In
                                </button>
                            )}

                            <div className="mjwi-frgt-pswrd" onClick={this.handleForgetPass}>{isSignUpActive ? "" : "Forgot password"}</div>
                            <span className="mjwi-error">{error}</span>

                        </form>
                    </div>
                    <div className="mjwi-rg-overlay-container">
                        <div className="mjwi-rg-overlay">
                            <div className={`mjwi-rg-overlay-panel ${isSignUpActive ? "mjwi-rg-overlay-left" : "mjwi-rg-overlay-right"}`}>
                                <h1>{isSignUpActive ? "Welcome Back!" : "Hello, Friend!"}</h1>
                                <p>{isSignUpActive ? "To keep connected with us, please login with your personal info" : "Enter your personal details and start the journey with us"}</p>
                                <button className="mjwi-rg-ghost" onClick={this.togglePanel}>
                                    {isSignUpActive ? "Sign In" : "Sign Up"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.showPopup && (
                    <div className="mjwi-editor-popup">
                        <div className="mjwi-editor-popup-content">
                            <span className="mjwi-editor-close" onClick={this.handleClosePopup}>
                                &times;
                            </span>
                            {this.state.popupMsg}
                        </div>
                    </div>
                )}
                <ForgotPasswordPopup ref={this.state.forgotPwdPp}/>
                <PasswordReqPopup ref={this.state.pwdReqPp}/>
            </div>
        );
    }
}

// export default Register;
const mapStateToProps = (state) => {
    return (
        {
            user: state.currentUser,
        }
    )
}
const mapDispatchToProps = (dispatch) => {
    return (
      {
        changeCurrentUser: (user) => { dispatch(changeCurrentUser(user)) },
      }
    )
  }
export default connect(mapStateToProps, mapDispatchToProps)(Register);